module.exports = __webpack_public_path__ + "img/invocie-succeess.c4646177.png";